/** `security` module DTOs unique keys */
export enum SecurityDtoKeysEnum {
  /** External user create request body */
  EXTERNAL_USER_CREATE_DTO = 'security/external-user-create.dto',
  /** External user response body */
  EXTERNAL_USER_FIND_DTO = 'security/external-user-find.dto',
  /** External users flat list API query parameters */
  EXTERNAL_USER_FLAT_LIST_QUERY_DTO = 'security/external-user-flat-list-query.dto',
  /** External user create/update request body */
  EXTERNAL_USER_FORM_DTO = 'security/external-user-form.dto',
  /** External user invite API query parameters */
  EXTERNAL_USER_INVITE_ONE_QUERY_DTO = 'security/external-user-invite-one-query.dto',
  /** External users list APIs filters */
  EXTERNAL_USER_LIST_FILTERS_DTO = 'security/external-user-list-filters.dto',
  /** External users pagination list API query parameters */
  EXTERNAL_USER_PAGE_LIST_QUERY_DTO = 'security/external-user-page-list-query.dto',
  /** External users pagination list API response body */
  EXTERNAL_USER_PAGE_DTO = 'security/external-user-page.dto',
  /** External user partial update API request body */
  EXTERNAL_USER_PARTIAL_FORM_DTO = 'security/external-user-partial-form.dto',
  USER_CHANGE_PASSWORD_DTO = 'security/user-change-password.dto',
  USER_DELETE_QUERY_DTO = 'security/user-delete-query.dto',
  USER_EMAIL_DTO = 'security/user-email.dto',
  USER_FIND_DTO = 'security/user-find.dto',
  USER_LOGIN_RESPONSE_DTO = 'security/user-login-response.dto',
  USER_LOGIN_DTO = 'security/user-login.dto',
  USER_NEED_DELEGATE_DTO = 'security/user-need-delegate.dto',
  USER_FORM_DTO = 'security/user-form.dto',
  USER_CREATE_DTO = 'security/user-create.dto',
  USER_UPDATE_DTO = 'security/user-update.dto',
  WORK_SCHEDULE_HOURS_DTO = 'security/work-schedule-hours.dto',
  WORK_SCHEDULE_FORM_DTO = 'security/work-schedule.form.dto',
  WORK_SCHEDULE_FIND_DTO = 'security/work-schedule.find.dto',
  /** Profile change password request body */
  PROFILE_CHANGE_PASSWORD_DTO = 'security/profile-change-password.dto',
  /** Profile response body */
  PROFILE_FIND_DTO = 'security/profile-find.dto',
  /** Profile flat list API query parameters */
  PROFILE_FLAT_LIST_QUERY_DTO = 'security/profile-flat-list-query.dto',
  /** Profile create/update request body */
  PROFILE_FORM_DTO = 'security/profile-form.dto',
  /** Profiles list APIs filters */
  PROFILE_LIST_FILTERS_DTO = 'security/profile-list-filters.dto',
  /** Profiles pagination list API response body */
  PROFILE_LIST_PAGE_DTO = 'security/profile-list-page.dto',
  /** Profile login API response body */
  PROFILE_LOGIN_FIND_DTO = 'security/profile-login-find.dto',
  /** Profile login API request body */
  PROFILE_LOGIN_FORM_DTO = 'security/profile-login-form.dto',
  /** Profile paginated list API query parameters */
  PROFILE_PAGE_LIST_QUERY_DTO = 'security/profile-page-list-query.dto',
  /** New profile register API request body */
  PROFILE_REGISTER_DTO = 'security/profile-register.dto',
  /** Profile password reset API request body */
  PROFILE_RESET_PASSWORD_DTO = 'security/profile-reset-password.dto',
  /** Profile email test API response body */
  PROFILE_TEST_EMAIL_FIND_DTO = 'security/profile-test-email-find.dto',
  /** Profile email test API query parameters */
  PROFILE_TEST_EMAIL_QUERY_DTO = 'security/profile-test-email-query.dto',
  USER_GROUP_MEMBER_FIND_DTO = 'security/user-group-member-find.dto',
  USER_GROUP_FIND_DTO = 'security/user-group-find.dto',
  USER_GROUP_FORM_DTO = 'security/user-group-form.dto',
  USER_GROUP_HISTORY_FIND_DTO = 'security/user-group-history-find.dto',
  USER_GROUP_HISTORY_RESPONSE_DTO = 'security/user-group-history-response.dto',
  USER_FIND_QUERY_DTO = 'security/user-find-query.dto',
  USER_LIST_FIND_DTO = 'security/user-list-find.dto',
  USER_FIND_ALL_QUERY_DTO = 'security/user-find-all-query.dto',
  /** Room access settings for user or group (response body) */
  ROOM_ACCESS_FIND_DTO = 'security/room-access-find.dto',
  /** Room access settings for user or group (create/update request body) */
  ROOM_ACCESS_FORM_DTO = 'security/room-access-form.dto',
  /** Access control rule for current authorized user */
  ACCESS_CONTROL_RULE_DTO = 'security/access-control-rule.dto',
  /** Base metadata for access control units (modules, groups and APIs) */
  ACCESS_CONTROL_UNIT_DTO = 'security/access-control-unit.dto',
  /** Access control permission for concrete business logic action */
  ACCESS_CONTROL_PERMISSION_DTO = 'security/access-control-permission.dto',
  /** Logical group of APIs. It can also contain child groups. */
  GROUP_FIND_DTO = 'security/group-find.dto',
  /** A module is the top level division of an application's APIs */
  MODULE_FIND_DTO = 'security/module-find.dto',
}
